import PropTypes from "prop-types";

export const KnownPathogenicityType = PropTypes.shape({
  version: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      benign: PropTypes.number,
      exon_deletion: PropTypes.arrayOf(PropTypes.number),
      frameshift: PropTypes.arrayOf(PropTypes.number),
      frequency_benign_threshold: PropTypes.number,
      frequency_histogram: PropTypes.shape({
        uncertain: PropTypes.number,
        benign: PropTypes.number,
        pathogenic: PropTypes.number,
        buckets: PropTypes.arrayOf(
          PropTypes.shape({
            benign: PropTypes.number,
            from: PropTypes.number,
            pathogenic: PropTypes.number,
            to: PropTypes.number,
            uncertain: PropTypes.number,
          })
        ),
      }),
      frequency_pathogenic_total: PropTypes.number,
      gene_id: PropTypes.number,
      gene_symbol: PropTypes.string,
      in_frame: PropTypes.arrayOf(PropTypes.number),
      missense: PropTypes.arrayOf(PropTypes.number),
      most_common_pathogenic_variant: PropTypes.string,
      most_common_pathogenic_variant_ethnicity: PropTypes.string,
      most_common_pathogenic_variant_frequency: PropTypes.number,
      non_coding: PropTypes.arrayOf(PropTypes.number),
      nonsense: PropTypes.arrayOf(PropTypes.number),
      pathogenic: PropTypes.number,
      splice_junction_loss: PropTypes.arrayOf(PropTypes.number),
      start_loss: PropTypes.arrayOf(PropTypes.number),
      stoploss: PropTypes.arrayOf(PropTypes.number),
      synonymous: PropTypes.arrayOf(PropTypes.number),
      total_frequencies: PropTypes.number,
      total_variants: PropTypes.number,
      totals: PropTypes.arrayOf(PropTypes.number),
      uncertain: PropTypes.number,
      version: PropTypes.string,
    })
  ),
});
